import { createContext, useMemo } from "react";

import type { ReactNode } from "react";

interface CarrierShipmentPageContextProps {
  children: ReactNode;
  shipment: CarrierCondensedShipment | undefined;
  onRefresh: VoidFunction;
  error: UIError | null;
}

interface CarrierShipmentPageContextState {
  onRefresh: VoidFunction | null;
  shipment: CarrierCondensedShipment | undefined;
  error: UIError | null;
}

export const carrierShipmentPageContext =
  createContext<CarrierShipmentPageContextState>({
    onRefresh: null,
    shipment: undefined,
    error: null,
  });

export function CarrierShipmentPageProvider(
  props: CarrierShipmentPageContextProps,
) {
  const { children, shipment, onRefresh, error } = props;

  const value = useMemo(
    () => ({
      shipment,
      onRefresh,
      error,
    }),
    [shipment, onRefresh, error],
  );

  return (
    <carrierShipmentPageContext.Provider value={value}>
      {children}
    </carrierShipmentPageContext.Provider>
  );
}
